import React, { useState, useEffect, useRef, useCallback } from 'react';
import { 
    ChevronLeft, 
    ChevronRight, 
    Play, 
    Pause,
    Building2,
    Sparkles,
    Trophy,
    Target,
    Zap,
    History,
    Calendar,
    Clock,
    ArrowDown,
    Menu,
    X
} from 'lucide-react';

const timelineData = [
    {
        year: 1987,
        title: 'GENESIS OF EXCELLENCE',
        content: 'Ray Consultants was founded establishing the foundation for what would become a legacy of engineering excellence.',
        icon: Sparkles,
        color: 'from-red-900 to-red-800',
        accentColor: 'burgundy',
        milestone: 'Foundation',
        id: 1,
    },
    {
        year: 1991,
        title: 'EARLY SUCCESS MILESTONE',
        content: 'Achieved our first project milestone of successfully completing 100 projects.',
        icon: Trophy,
        color: 'from-red-800 to-red-700',
        accentColor: 'burgundy',
        milestone: 'First Success',
        id: 2,
    },
    {
        year: 1993,
        title: 'TEAM EXPANSION',
        content: 'Ray Infrastructure familiy grew to 50+ professionals, marking a significant step in our journey towards becoming a leading infrastructure consultancy.',
        icon: Target,
        color: 'from-red-900 to-red-800',
        accentColor: 'burgundy',
        milestone: 'Growth',
        id: 3,
    },
    {
        year: 1995,
        title: 'STRATEGIC PARTNERSHIP EVOLUTION',
        content: 'Transformed into a partnership firm with the inclusion of additional partners, expanding our expertise and market reach across diverse engineering disciplines.',
        icon: Building2,
        color: 'from-red-800 to-red-700',
        accentColor: 'burgundy',
        milestone: 'Partnership',
        id: 4,
    },
    {
        year: 1997,
        title: 'PROJECT PORTFOLIO GROWTH',
        content: 'Significant expansion in project delivery capabilities. Successfully completed 1000+ projects.',
        icon: Zap,
        color: 'from-red-900 to-red-800',
        accentColor: 'burgundy',
        milestone: 'Expansion',
        id: 5,
    },
    {
        year: 1999,
        title: 'CORPORATE TRANSFORMATION',
        content: 'Officially incorporated under the Companies Act and rebranded as Ray Infrastructures Pvt. Ltd., marking our evolution into a comprehensive infrastructure consultancy powerhouse.',
        icon: History,
        color: 'from-red-800 to-red-700',
        accentColor: 'burgundy',
        milestone: 'Incorporation',
        id: 6,
    },
    {
        year: 2001,
        title: 'ORGANIZATIONAL STRENGTH',
        content: 'Substantial team growth. Ray Infrastructure family grew to over 100 employees.',
        icon: Trophy,
        color: 'from-red-900 to-red-800',
        accentColor: 'burgundy',
        milestone: 'Strength',
        id: 7,
    },
    {
        year: 2003,
        title: 'INTERNATIONAL RECOGNITION',
        content: 'Secured prestigious Asian Development Bank (ADB) funded projects and Gujarat Earthquake Rehabilitation initiatives, showcasing our disaster resilience expertise.',
        icon: Sparkles,
        color: 'from-red-800 to-red-700',
        accentColor: 'burgundy',
        milestone: 'Recognition',
        id: 8,
    },
    {
        year: 2004,
        title: 'ENGINEERING EXCELLENCE MILESTONE',
        content: 'Reached significant project delivery benchmarks, over 2000 projects completed.',
        icon: Target,
        color: 'from-red-900 to-red-800',
        accentColor: 'burgundy',
        milestone: 'Excellence',
        id: 9,
    },
    {
        year: 2006,
        title: 'MARKET LEADERSHIP ACHIEVEMENT',
        content: 'Established ourselves as a major player in the infrastructure consultancy sector with with over 5000 projects delivered, setting new industry standards.',
        icon: Building2,
        color: 'from-red-800 to-red-700',
        accentColor: 'burgundy',
        milestone: 'Leadership',
        id: 10,
    },
    {
        year: 2011,
        title: 'PROFESSIONAL EXCELLENCE',
        content: 'Ray Infrastructure family grew to over 150 professionals, enhancing our capabilities and service delivery.',
        icon: Zap,
        color: 'from-red-900 to-red-800',
        accentColor: 'burgundy',
        milestone: 'Excellence',
        id: 11,
    },
    {
        year: 2013,
        title: 'LANDMARK CONTRACT AWARD',
        content: 'Secured a transformational ₹180 Crore single consultancy contract, demonstrating client confidence in our large-scale project management capabilities.',
        icon: Trophy,
        color: 'from-red-800 to-red-700',
        accentColor: 'burgundy',
        milestone: 'Landmark',
        id: 12,
    },
    {
        year: 2014,
        title: 'WORKFORCE EXCELLENCE',
        content: 'Significant workforce expansion with over 500 professionals, enhancing our technical expertise and project delivery capabilities.',
        icon: Target,
        color: 'from-red-900 to-red-800',
        accentColor: 'burgundy',
        milestone: 'Excellence',
        id: 13,
    },
    {
        year: 2017,
        title: 'LEADERSHIP TRANSITION',
        content: 'Strategic management transition ushering in new leadership vision while maintaining our core values of technical excellence and client satisfaction.',
        icon: History,
        color: 'from-red-800 to-red-700',
        accentColor: 'burgundy',
        milestone: 'Transition',
        id: 14,
    },
    {
        year: 2019,
        title: 'DECADE OF ACHIEVEMENT',
        content: 'Reached unprecedented project delivery milestones with over 10,000 projects completed, solidifying our position as a leader in the infrastructure consultancy sector.',
        icon: Sparkles,
        color: 'from-red-900 to-red-800',
        accentColor: 'burgundy',
        milestone: 'Achievement',
        id: 15,
    },
    {
        year: 2025,
        title: 'GLOBAL VISION REALIZED',
        content: "Spreading wings toward a global horizon with 15,000+ successful projects completed, embodying our mission of 'Engineering a Better Tomorrow' across diverse infrastructure sectors.",
        icon: Building2,
        color: 'from-red-800 to-red-700',
        accentColor: 'burgundy',
        milestone: 'Vision',
        id: 16,
    },
];

const RayJourneyTimeline = () => {
    // Add custom CSS for animations
    React.useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            @keyframes float {
                0%, 100% { transform: translateY(0px) rotate(0deg); }
                50% { transform: translateY(-10px) rotate(180deg); }
            }
            @keyframes fadeIn {
                from { opacity: 0; transform: translateY(20px); }
                to { opacity: 1; transform: translateY(0px); }
            }
            .animate-fade-in {
                animation: fadeIn 0.6s ease-out forwards;
            }
        `;
        document.head.appendChild(style);
        return () => document.head.removeChild(style);
    }, []);

    const [activeIndex, setActiveIndex] = useState(0);
    const [isAutoPlaying, setIsAutoPlaying] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [scrollDirection, setScrollDirection] = useState('down');
    
    const autoPlayRef = useRef(null);
    const observerRef = useRef(null);
    const itemRefs = useRef([]);
    const lastScrollY = useRef(0);

    // Enhanced loading animation
    useEffect(() => {
        const timer = setTimeout(() => setIsLoaded(true), 500);
        return () => clearTimeout(timer);
    }, []);

    // Scroll direction detection
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setScrollDirection(currentScrollY > lastScrollY.current ? 'down' : 'up');
            lastScrollY.current = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Enhanced auto-play functionality
    useEffect(() => {
        if (isAutoPlaying) {
            autoPlayRef.current = setInterval(() => {
                setActiveIndex(prev => {
                    const nextIndex = prev === timelineData.length - 1 ? 0 : prev + 1;
                    // Smooth scroll to next item
                    setTimeout(() => {
                        itemRefs.current[nextIndex]?.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    }, 100);
                    return nextIndex;
                });
            }, 5000);
        } else {
            clearInterval(autoPlayRef.current);
        }

        return () => clearInterval(autoPlayRef.current);
    }, [isAutoPlaying]);

    // Enhanced Intersection Observer
    useEffect(() => {
        observerRef.current = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const index = itemRefs.current.indexOf(entry.target);
                        if (index !== -1) {
                            setActiveIndex(index);
                        }
                    }
                });
            },
            {
                threshold: 0.4,
                rootMargin: '-15% 0px -15% 0px'
            }
        );

        itemRefs.current.forEach((ref) => {
            if (ref) observerRef.current.observe(ref);
        });

        return () => {
            if (observerRef.current) {
                observerRef.current.disconnect();
            }
        };
    }, []);

    // Navigation functions
    const goToSlide = useCallback((index) => {
        setActiveIndex(index);
        setIsAutoPlaying(false);
        setIsMobileMenuOpen(false);
        itemRefs.current[index]?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }, []);

    const goToPrevious = useCallback(() => {
        const newIndex = activeIndex === 0 ? timelineData.length - 1 : activeIndex - 1;
        goToSlide(newIndex);
    }, [activeIndex, goToSlide]);

    const goToNext = useCallback(() => {
        const newIndex = activeIndex === timelineData.length - 1 ? 0 : activeIndex + 1;
        goToSlide(newIndex);
    }, [activeIndex, goToSlide]);

    const toggleAutoPlay = useCallback(() => {
        setIsAutoPlaying(prev => !prev);
    }, []);

    // Enhanced keyboard navigation
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
            
            switch (e.key) {
                case 'ArrowUp':
                case 'ArrowLeft':
                    e.preventDefault();
                    goToPrevious();
                    break;
                case 'ArrowDown':
                case 'ArrowRight':
                    e.preventDefault();
                    goToNext();
                    break;
                case ' ':
                    e.preventDefault();
                    toggleAutoPlay();
                    break;
                case 'Escape':
                    setIsMobileMenuOpen(false);
                    setIsAutoPlaying(false);
                    break;
                default:
                    break;
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [goToPrevious, goToNext, toggleAutoPlay]);

    const getAccentClasses = (accentColor) => {
        const colorMap = {
            burgundy: { bg: 'bg-red-800', border: 'border-red-400', text: 'text-red-800', ring: 'ring-red-800/20' },
        };
        return colorMap[accentColor] || colorMap.burgundy;
    };

    return (
        <div className={`min-h-screen bg-gradient-to-br from-red-50 via-white to-red-100 transition-all duration-1000 relative overflow-hidden ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
            {/* BALANCED Visible Patterns */}
            <div className="fixed inset-0 opacity-50 pointer-events-none">
                {/* Clean Dot Grid Pattern */}
                <div className="absolute inset-0" style={{
                    backgroundImage: `radial-gradient(circle at 2px 2px, rgba(185, 28, 28, 0.3) 1px, transparent 0)`,
                    backgroundSize: '50px 50px'
                }}></div>
                
                {/* Subtle Diagonal Accent */}
                <div className="absolute inset-0" style={{
                    backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 80px, rgba(185, 28, 28, 0.15) 80px, rgba(185, 28, 28, 0.15) 82px)`,
                }}></div>

                {/* Nice Floating Geometric Shapes */}
                <div className="absolute top-32 left-32 w-40 h-40 border border-red-300/50 rounded-full animate-pulse" style={{ animationDuration: '6s' }}></div>
                <div className="absolute top-2/3 right-32 w-32 h-32 border border-red-400/60 rotate-45 animate-pulse" style={{ animationDuration: '8s', animationDelay: '2s' }}></div>
                <div className="absolute bottom-40 left-1/3 w-24 h-24 border border-red-300/50 rounded-lg animate-pulse" style={{ animationDuration: '7s', animationDelay: '1s' }}></div>
                
                {/* Clean Hexagon Accents */}
                <div className="absolute top-0 right-0 w-full h-full opacity-40">
                    {[...Array(4)].map((_, i) => (
                        <div
                            key={i}
                            className="absolute border border-red-300/60"
                            style={{
                                width: '60px',
                                height: '60px',
                                clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                                top: `${15 + i * 25}%`,
                                right: `${15 + (i % 2) * 30}%`,
                                transform: `rotate(${i * 45}deg)`,
                                animation: `float ${5 + i}s infinite ease-in-out`,
                                animationDelay: `${i * 0.8}s`
                            }}
                        />
                    ))}
                </div>

                {/* Clean Tech Grid */}
                <div className="absolute inset-0 opacity-20" style={{
                    backgroundImage: `
                        linear-gradient(rgba(185, 28, 28, 0.3) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(185, 28, 28, 0.3) 1px, transparent 1px)
                    `,
                    backgroundSize: '60px 60px'
                }}></div>
            </div>

            <div className="flex">
                {/* Ultra Minimal Sidebar - Fixed but only visible during timeline */}
                <div className="hidden xl:block w-14 fixed left-6 z-30" style={{ top: 'max(8rem, 10vh)', bottom: 'max(8rem, 10vh)' }}>
                    <div className="h-full flex flex-col">
                        <div className="bg-white/95 backdrop-blur-sm rounded-xl border border-red-100/50 shadow-sm p-4 h-full flex flex-col relative overflow-hidden">
                            
                            {/* Balanced sidebar pattern */}
                            <div className="absolute inset-0 opacity-20 pointer-events-none">
                                <div style={{
                                    backgroundImage: `
                                        linear-gradient(90deg, rgba(185, 28, 28, 0.4) 1px, transparent 1px),
                                        linear-gradient(rgba(185, 28, 28, 0.2) 1px, transparent 1px)
                                    `,
                                    backgroundSize: '12px 12px, 6px 6px'
                                }} className="w-full h-full"></div>
                            </div>
                            
                            {/* Minimal Header */}
                            <div className="text-center mb-6 pb-2">
                            </div>

                            {/* Ultra Clean Timeline */}
                            <div className="flex-1 relative">
                                {/* Thin Line */}
                                <div className="absolute left-1/2 top-0 bottom-0 w-px bg-red-100 transform -translate-x-1/2"></div>
                                
                                {/* Progress Line */}
                                <div 
                                    className="absolute left-1/2 top-0 w-px bg-red-700 transform -translate-x-1/2 transition-all duration-700"
                                    style={{ height: `${((activeIndex + 1) / timelineData.length) * 100}%` }}
                                />

                                {/* Simple Dots */}
                                <div className="relative h-full py-1">
                                    {timelineData.map((item, index) => {
                                        const isActive = index === activeIndex;
                                        const isPassed = index < activeIndex;
                                        const position = (index / (timelineData.length - 1)) * 100;
                                        
                                        return (
                                            <button
                                                key={item.id}
                                                onClick={() => goToSlide(index)}
                                                className="absolute left-1/2 transform -translate-x-1/2 group"
                                                style={{
                                                    top: `${position}%`,
                                                    transform: 'translate(-50%, -50%)'
                                                }}
                                            >
                                                {/* Ultra Simple Dot */}
                                                <div className={`w-5 h-5 rounded-full border transition-all duration-300 flex items-center justify-center ${
                                                    isActive 
                                                        ? 'bg-red-700 border-red-700' 
                                                        : isPassed
                                                        ? 'bg-red-50 border-red-200'
                                                        : 'bg-transparent border-red-150 hover:border-red-300'
                                                }`}>
                                                    <span className={`text-2xs font-medium leading-none ${
                                                        isActive ? 'text-white' : isPassed ? 'text-red-600' : 'text-red-400'
                                                    }`}>
                                                        {item.year.toString().slice(-2)}
                                                    </span>
                                                </div>

                                                {/* Minimal Tooltip */}
                                                <div className="absolute left-full ml-2 top-1/2 transform -translate-y-1/2 bg-red-800 text-white px-2 py-1 rounded text-2xs opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap">
                                                    {item.year}
                                                </div>
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* Minimal Footer */}
                            <div className="text-center mt-6">
                                <div className="text-2xs text-red-600 mb-2 font-medium">
                                    {activeIndex + 1}/{timelineData.length}
                                </div>
                                <div className="w-6 h-0.5 bg-red-100 rounded-full mx-auto overflow-hidden">
                                    <div 
                                        className="h-full bg-red-700 transition-all duration-500"
                                        style={{ width: `${((activeIndex + 1) / timelineData.length) * 100}%` }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Enhanced Main Content */}
                <main className="flex-1 xl:ml-20">
                    <div className="space-y-0">
                        {timelineData.map((item, index) => {
                            const isActive = index === activeIndex;
                            const IconComponent = item.icon;
                            const colors = getAccentClasses(item.accentColor);
                            
                            return (
                                <section
                                    key={item.id}
                                    ref={el => itemRefs.current[index] = el}
                                    className="min-h-[40vh] flex items-center px-4 sm:px-6 lg:px-8 py-8 lg:py-12"
                                >
                                    <div className="max-w-5xl mx-auto w-full">
                                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 items-center">
                                            {/* Enhanced Year Display */}
                                            <div className="lg:col-span-4 text-center lg:text-right">
                                                <div className="relative group">
                                                    <div 
                                                        className={`text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-black transition-all duration-700 ${
                                                            isActive 
                                                                ? `bg-gradient-to-r ${item.color} bg-clip-text text-transparent transform scale-110 drop-shadow-sm` 
                                                                : 'text-slate-200/80'
                                                        }`}
                                                    >
                                                        {item.year}
                                                    </div>
                                                    
                                                    {/* Floating particles effect */}
                                                    {isActive && (
                                                        <div className="absolute inset-0 overflow-hidden pointer-events-none">
                                                            {[...Array(3)].map((_, i) => (
                                                                <div
                                                                    key={i}
                                                                    className={`absolute w-2 h-2 bg-red-800 rounded-full opacity-60 animate-ping`}
                                                                    style={{
                                                                        left: `${20 + i * 30}%`,
                                                                        top: `${30 + i * 20}%`,
                                                                        animationDelay: `${i * 0.5}s`,
                                                                        animationDuration: '2s'
                                                                    }}
                                                                />
                                                            ))}
                                                        </div>
                                                    )}
                                                    
                                                    <div className={`mt-3 text-sm font-bold uppercase tracking-widest transition-all duration-500 ${
                                                        isActive ? 'text-red-800' : 'text-red-400'
                                                    }`}>
                                                        {item.milestone}
                                                    </div>
                                                </div>

                                                {/* Mobile Timeline Connector */}
                                                <div className="lg:hidden flex justify-center mt-4 mb-4">
                                                    <div className={`relative w-12 h-12 rounded-full border-4 flex items-center justify-center transition-all duration-500 ${
                                                        isActive
                                                            ? `bg-gradient-to-r ${item.color} border-transparent shadow-xl shadow-red-800/25 scale-110`
                                                            : 'bg-white border-red-300 shadow-lg'
                                                    }`}>
                                                        <IconComponent className={`w-5 h-5 transition-colors duration-500 ${
                                                            isActive ? 'text-white' : 'text-red-400'
                                                        }`} />
                                                        
                                                        {isActive && (
                                                            <div className="absolute inset-0 rounded-full bg-gradient-to-r from-transparent via-white/20 to-transparent animate-spin" style={{ animationDuration: '3s' }}></div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Enhanced Content Card */}
                                            <div className="lg:col-span-8">
                                                <div 
                                                    className={`relative bg-white/80 backdrop-blur-sm rounded-3xl p-6 sm:p-8 lg:p-10 border shadow-xl transition-all duration-700 overflow-hidden ${
                                                        isActive 
                                                            ? `border-red-400 shadow-2xl shadow-red-800/10 transform scale-105` 
                                                            : 'border-red-200/50 shadow-red-900/5'
                                                    }`}
                                                >
                                                    {/* Balanced Background Pattern */}
                                                    <div className="absolute top-0 right-0 w-32 h-32 opacity-15">
                                                        <div className={`w-full h-full bg-gradient-to-br ${item.color} rounded-full blur-xl`}></div>
                                                    </div>
                                                    
                                                    {/* Balanced Card Pattern Overlay */}
                                                    <div className="absolute inset-0 opacity-10 pointer-events-none">
                                                        <div style={{
                                                            backgroundImage: `
                                                                radial-gradient(circle at 1px 1px, rgba(185, 28, 28, 0.4) 1px, transparent 0)
                                                            `,
                                                            backgroundSize: '25px 25px'
                                                        }} className="w-full h-full"></div>
                                                    </div>

                                                    {/* Nice Decorative Corner Elements */}
                                                    {isActive && (
                                                        <>
                                                            <div className="absolute top-4 left-4 w-10 h-10 border-l-2 border-t-2 border-red-300/60 rounded-tl-lg"></div>
                                                            <div className="absolute bottom-4 right-4 w-10 h-10 border-r-2 border-b-2 border-red-300/60 rounded-br-lg"></div>
                                                        </>
                                                    )}

                                                    {/* Content Header */}
                                                    <div className="relative flex items-start space-x-4 mb-6">
                                                        <div className={`hidden lg:flex p-3 rounded-2xl transition-all duration-500 shadow-lg ${
                                                            isActive 
                                                                ? `bg-gradient-to-r ${item.color} shadow-red-800/25` 
                                                                : 'bg-red-100 shadow-red-900/5'
                                                        }`}>
                                                            <IconComponent className={`w-6 h-6 transition-colors duration-500 ${
                                                                isActive ? 'text-white' : 'text-red-400'
                                                            }`} />
                                                        </div>
                                                        
                                                        <div className="flex-1">
                                                            <h2 className={`text-xl sm:text-2xl lg:text-3xl font-bold mb-3 transition-colors duration-500 leading-tight ${
                                                                isActive ? 'text-gray-900' : 'text-gray-600'
                                                            }`}>
                                                                {item.title}
                                                            </h2>
                                                            <div className={`inline-flex items-center space-x-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider transition-all duration-500 ${
                                                                isActive 
                                                                    ? `bg-gradient-to-r ${item.color} text-white shadow-lg` 
                                                                    : 'bg-red-100 text-red-500'
                                                            }`}>
                                                                <span>{item.year}</span>
                                                                <span>•</span>
                                                                <span>{item.milestone}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Content Body */}
                                                    <div className="relative">
                                                        <p className={`text-base leading-relaxed transition-colors duration-500 ${
                                                            isActive ? 'text-gray-700' : 'text-gray-500'
                                                        }`}>
                                                            {item.content}
                                                        </p>

                                                        {/* Active Indicator */}
                                                        {isActive && (
                                                            <div className="mt-6 flex items-center space-x-4 animate-fade-in">
                                                                <div className="flex items-center space-x-3">
                                                                    <div className={`w-3 h-3 rounded-full bg-gradient-to-r ${item.color} animate-pulse shadow-lg`}></div>
                                                                    <span className="text-sm font-semibold text-gray-600">Currently viewing</span>
                                                                </div>
                                                                <div className={`flex-1 h-px bg-gradient-to-r ${item.color} opacity-20`}></div>
                                                                <ArrowDown className="w-4 h-4 text-gray-400 animate-bounce" />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            );
                        })}
                    </div>
                </main>
            </div>

            {/* Progress indicator - Fixed but constrained */}
            <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 bg-white/90 backdrop-blur-xl px-6 py-4 rounded-2xl border border-red-200/50 shadow-xl z-20 relative overflow-hidden">
                {/* Balanced pattern overlay */}
                <div className="absolute inset-0 opacity-15 pointer-events-none">
                    <div style={{
                        backgroundImage: `radial-gradient(circle at 1px 1px, rgba(185, 28, 28, 0.4) 1px, transparent 0)`,
                        backgroundSize: '8px 8px'
                    }} className="w-full h-full"></div>
                </div>
                
                <div className="flex items-center space-x-4 relative">
                    <div className="flex items-center space-x-3">
                        <div className={`p-2.5 rounded-xl bg-gradient-to-r ${timelineData[activeIndex]?.color} text-white shadow-lg`}>
                            <Clock className="w-4 h-4" />
                        </div>
                        <div>
                            <div className="text-sm font-bold text-red-800">
                                {Math.round(((activeIndex + 1) / timelineData.length) * 100)}% Complete
                            </div>
                            <div className="text-xs text-red-600 font-medium">
                                {timelineData[activeIndex]?.year} • {timelineData[activeIndex]?.milestone}
                            </div>
                        </div>
                    </div>
                    
                    <div className="w-32 sm:w-40 h-2.5 bg-red-200 rounded-full overflow-hidden shadow-inner">
                        <div
                            className={`h-full bg-gradient-to-r ${timelineData[activeIndex]?.color} transition-all duration-500 rounded-full shadow-sm`}
                            style={{ width: `${((activeIndex + 1) / timelineData.length) * 100}%` }}
                        />
                    </div>
                    
                    {isAutoPlaying && (
                        <div className="flex items-center space-x-2 text-xs text-red-800 bg-red-50 px-3 py-1.5 rounded-full border border-red-200 animate-pulse">
                            <div className="w-2 h-2 bg-red-800 rounded-full animate-ping"></div>
                            <span className="font-semibold">Auto Play</span>
                        </div>
                    )}
                </div>
            </div>

            {/* Mobile navigation - Fixed but constrained */}
            <div className="xl:hidden fixed bottom-28 right-4 bg-white/90 backdrop-blur-xl rounded-2xl border border-red-200/50 shadow-xl p-3 z-20">
                <div className="text-center text-xs font-semibold text-red-600 mb-3">Navigate</div>
                <div className="flex space-x-2">
                    <button
                        onClick={goToPrevious}
                        className="p-3 rounded-xl bg-gradient-to-r from-red-100 to-red-50 hover:from-red-200 hover:to-red-100 text-red-800 transition-all duration-200 hover:scale-105 shadow-sm"
                        aria-label="Previous"
                    >
                        <ChevronLeft className="w-4 h-4" />
                    </button>
                    <button
                        onClick={goToNext}
                        className="p-3 rounded-xl bg-gradient-to-r from-red-100 to-red-50 hover:from-red-200 hover:to-red-100 text-red-800 transition-all duration-200 hover:scale-105 shadow-sm"
                        aria-label="Next"
                    >
                        <ChevronRight className="w-4 h-4" />
                    </button>
                </div>
            </div>

            {/* Loading Overlay */}
            {!isLoaded && (
                <div className="fixed inset-0 bg-white z-50 flex items-center justify-center">
                    <div className="text-center">
                        <div className="relative">
                            <div className="w-16 h-16 border-4 border-red-200 rounded-full animate-spin border-t-red-800 mx-auto mb-4"></div>
                            <div className="absolute inset-0 w-16 h-16 border-4 border-transparent rounded-full animate-ping border-t-red-600 mx-auto"></div>
                        </div>
                        <p className="text-red-600 font-medium">Loading our journey...</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RayJourneyTimeline;